var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniLibrary02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.304688,
    y: 0.710938,
    width: 258,
    height: 252,
    fill: "#D9894F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_500_12642",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.304688,
    y: 0.710938,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_500_12642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8398 156.485L172.065 201.585L270.044 157.523L139.085 106.51L49.8398 156.485Z",
    fill: "#0C1A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7461 147.036L194.527 191.624L271.885 157.242L145.104 112.654L67.7461 147.036Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5957 124.642L194.339 164.916L256.225 137.317L144.482 97.043L82.5957 124.642Z",
    fill: "#373943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.565 103.7L256.308 143.975L256.307 132.515L144.564 92.2402L144.565 103.7Z",
    fill: "#4A4D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.552 103.676L82.7425 131.248L82.7422 119.812L144.551 92.2402L144.552 103.676Z",
    fill: "#202129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.555 103.676L141.781 104.916L135.793 96.1367L144.554 92.2402L144.555 103.676Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.555 103.676L249.811 141.701V130.019L144.555 92.2402L144.555 103.676Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.552 103.676L244.067 139.556L240.175 140.954L141.785 104.919L144.552 103.676Z",
    fill: "#21232C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.523 165.837L67.7422 121.248L145.1 86.8672L271.881 131.455L194.523 165.837ZM194.42 160.111L82.677 119.837L144.563 92.2384L256.306 132.513L194.42 160.111Z",
    fill: "#CBE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.523 165.837L67.7422 121.248L145.1 86.8672L271.881 131.455L194.523 165.837ZM194.42 160.111L82.677 119.837L144.563 92.2384L256.306 132.513L194.42 160.111Z",
    fill: "url(#paint0_linear_500_12642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7461 121.248L194.527 165.828V191.622L67.7461 147.034V121.248Z",
    fill: "#213547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.883 131.457L194.525 165.837V191.624L271.883 157.243V131.457Z",
    fill: "#416E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.072 113.336L213.765 146.974L219.719 143.859L128.453 111.184L124.072 113.336Z",
    fill: "#21232C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.518 108.959L216.33 142.036L216.33 145.203L126.518 112.125L126.518 108.959Z",
    fill: "#CC8259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.518 108.957L216.33 142.034L219.923 140.161L130.111 107.084L126.518 108.957Z",
    fill: "#FFB287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.195 130.984L216.325 141.644L219.918 139.771L190.789 129.111L187.195 130.984Z",
    fill: "#E87F45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.193 134.224L210.343 139.148L212.356 138.104L199.206 133.18L197.193 134.224Z",
    fill: "#563320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.607 141.079L215.285 140.346L217.299 139.301L217.71 139.91L215.607 141.079Z",
    fill: "#EC9D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.59 133.777L215.287 140.347L215.607 141.083L210.199 139.084L209.902 138.708L197.189 133.958L197.59 133.777Z",
    fill: "#CC8259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.588 133.777L215.285 140.347L217.298 139.302L199.601 132.732L197.588 133.777Z",
    fill: "#FFB287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.584 133.778L197.207 133.95L199.221 132.905L199.598 132.732L197.584 133.778Z",
    fill: "#B88467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.326 145.674L216.324 141.643L219.918 139.77L219.919 143.801L216.326 145.674Z",
    fill: "#783814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.195 130.982L216.337 141.672V145.706L187.195 134.956V130.982Z",
    fill: "#9E4E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.166 142.865L246.166 136.932L257.768 131.861L270.048 132.348L246.166 142.865Z",
    fill: "#32485C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.472 160.098L246.141 142.83L271.964 131.447L271.881 157.244L265.472 160.098Z",
    fill: "#213547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.881 86.0767L246.624 126.351L306.097 124.243L194.355 83.9688L134.881 86.0767Z",
    fill: "#CBE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.881 86.0767L246.624 126.351L306.097 124.243L194.355 83.9688L134.881 86.0767Z",
    fill: "url(#paint1_linear_500_12642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.621 135.684V126.35L306.095 124.242L306.096 132.441L246.621 135.684Z",
    fill: "#416E97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.638 135.705V126.371L134.881 86.0742L134.883 94.2733L246.638 135.705Z",
    fill: "#213547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.973 242.711V222.914H189.738C194.236 222.914 196.82 225.689 196.82 229.586C196.82 233.537 194.195 236.258 189.629 236.258H186.074V242.711H181.973ZM186.074 232.949H188.973C191.406 232.949 192.596 231.582 192.582 229.586C192.596 227.617 191.406 226.291 188.973 226.277H186.074V232.949ZM200.785 242.957C199.5 242.957 198.461 241.932 198.488 240.66C198.461 239.402 199.5 238.377 200.785 238.391C202.002 238.377 203.055 239.402 203.055 240.66C203.055 241.932 202.002 242.957 200.785 242.957ZM206.391 242.711V222.914H214.156C218.654 222.914 221.238 225.689 221.238 229.586C221.238 233.537 218.613 236.258 214.047 236.258H210.492V242.711H206.391ZM210.492 232.949H213.391C215.824 232.949 217.014 231.582 217 229.586C217.014 227.617 215.824 226.291 213.391 226.277H210.492V232.949ZM227.801 222.914V242.711H223.754V222.914H227.801ZM237.672 243.012C233.119 242.998 230.33 240.059 230.344 235.355C230.33 230.775 233.16 227.672 237.508 227.672C241.404 227.672 244.48 230.133 244.48 235.191V236.34H234.336C234.336 238.582 235.662 239.963 237.754 239.977C239.135 239.963 240.119 239.361 240.516 238.473H244.371C243.797 241.221 241.336 242.998 237.672 243.012ZM234.336 233.797H240.652C240.639 231.992 239.395 230.693 237.59 230.707C235.73 230.693 234.418 232.088 234.336 233.797Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_500_12642",
    x1: 225.784,
    y1: 110.461,
    x2: 211.743,
    y2: 147.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_500_12642",
    x1: 230.399,
    y1: 89.4011,
    x2: 218.965,
    y2: 118.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE6FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLibrary02);
export default __webpack_public_path__ + "static/media/mini_library_02.f55613f67300bcf5e2316fb1d131b7f8.svg";
export { ForwardRef as ReactComponent };